import { createSlice } from "@reduxjs/toolkit";
import { readFromSessionStorage, saveToSessionStorage } from "utils/helper";

const initialState = {
  data: (() => {
    const storedData = readFromSessionStorage("currentOccupant");
    return storedData ? storedData : null;
  })(),
  isOccupantSet: false,
  error: "",
};

export const currentOccupant = createSlice({
  name: "currentOccupant",
  initialState,
  reducers: {
    setOccupantBegin: (state) => {
      state.data = null;
      state.error = "";
    },

    setOccupantSuccess: (state, action) => {
      state.data = action.payload;
      const tempObj = {
        ...action.payload,
        occupantGraphic: "",
      };
      saveToSessionStorage("currentOccupant", tempObj);
    },

    setOccupantError: (state, action) => {
      sessionStorage.removeItem("currentOccupant");
      state.data = null;
      state.error = action.payload;
    },

    resetState: (state) => {
      return initialState;
    },
  },
});

export const { setOccupantBegin, setOccupantSuccess, setOccupantError } =
  currentOccupant.actions;

export const currentOccupantSelector = (state) => state.currentOccupant.data;

export default currentOccupant.reducer;
